import React, { Component } from "react";

import { remoteLog } from "../../../../common/logging";
import { redirectTo } from "../../../../common/navigation";
import Notification from "../../../notification";
import { notificationCustomStyle } from "../../../notifications/notification_styles";
import { PageFooter } from "../../../page_footer";
import { PageHeader } from "../../../page_header";
import { PatientMenu } from "../../../patient_menu";
import PaymentInvoiceSuccess from "./payment_invoice_success";

const redirectToPatients = () => {
  redirectTo("/pages/payments");
};

class PaymentInvoiceSuccessBody extends Component {
  componentDidCatch(e) {
    remoteLog(e, "payment_invoice_success_body");
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      redirectToPatients();
      this.timer = 0;
    }, 15000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = 0;
    }
  }

  render() {
    // Embedded in the redesign shell (`bareLayout`): the shell supplies header/nav/footer, so render only
    // the notifications + the result body. Same content either way; this is purely presentational.
    if (this.props.bareLayout) {
      return (
        <>
          <Notification style={notificationCustomStyle} />
          <PaymentInvoiceSuccess {...this.props} />
        </>
      );
    }

    return (
      <div>
        <PageHeader {...this.props} />
        <div className="container">
          <div className="page-container">
            <PatientMenu {...this.props} />
            <Notification style={notificationCustomStyle} />
            <PaymentInvoiceSuccess {...this.props} />
          </div>
          <PageFooter {...this.props} />
        </div>
      </div>
    );
  }
}

export default PaymentInvoiceSuccessBody;
